import React from 'react';
import ReactDOM from 'react-dom';
import './css/normalize.css';
import './css/variables.css';
import './css/index.css';
import './css/skeleton.css';
import App from './components/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
